import { useMutation, useQueryClient } from '@tanstack/react-query';
import { QUERY_KEYS_ENUM } from '../../static/query-keys.enum';
import { useToastMessage } from '../useQueryHelper';
import { handleAxiosError } from '../../api/error-handler/error-handler';
import { editComment } from '../../api/checker-maker';

export const useEditComment = () => {
  const { openToast } = useToastMessage();
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: [QUERY_KEYS_ENUM.editComment],
    mutationFn: editComment,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS_ENUM.getCommentList] });
      openToast({ label: 'Komen berhasil diupdate' });
    },
    onError: (error) => {
      const message = handleAxiosError(error);
      openToast({ label: message, isError: true });
    }
  });
};
